export const emojiArray = [
  { name: 'Grinning Face', code: '😀' },
  { name: 'Rolling on the Floor Laughing', code: '🤣' },
  { name: 'Face with Tears of Joy', code: '😂' },
  { name: 'Smiling Face with Heart-Eyes', code: '😍' },
  { name: 'Red Heart', code: '❤️' },
  { name: 'Thumbs Up', code: '👍' },
  { name: 'Thumbs Down', code: '👎' },
  { name: 'OK Hand', code: '👌' },
  { name: 'Raised Fist', code: '✊' },
  { name: 'Raised Hand', code: '✋' },
  { name: 'Waving Hand', code: '👋' },
  { name: 'Clapping Hands', code: '👏' },
  { name: 'Party Popper', code: '🎉' },
  { name: 'Fire', code: '🔥' },
  { name: 'Exploding Head', code: '🤯' },
  { name: 'Thinking Face', code: '🤔' },
  { name: 'Face with Symbols on Mouth', code: '🤬' },
  { name: 'Zipper-Mouth Face', code: '🤐' },
  { name: 'Face with Rolling Eyes', code: '🙄' },
  { name: 'Pouting Face', code: '😡' },
  { name: 'Crying Face', code: '😢' },
  { name: 'Face with Medical Mask', code: '😷' },
  { name: 'Face with Sunglasses', code: '😎' },
  { name: 'Nerd Face', code: '🤓' },
  { name: 'Money-Mouth Face', code: '🤑' },
  { name: 'Slightly Smiling Face', code: '🙂' },
  { name: 'Neutral Face', code: '😐' },
  { name: 'Flushed Face', code: '😳' },
  { name: 'Weary Face', code: '😩' },
  { name: 'Sleeping Face', code: '😴' },
];
